<template>
  <div id="charity">
    <b-card overlay :img-src="gif" class="text-center" img-height="350px">
      <span class="card-header text-center">
        <strong>Twitch Charity</strong>
      </span>
      <div
        v-if="progress < target"
        @mouseover="sendEvent('charity', 'hover', 'charity-gauge-interaction')"
      >
        <br />
        <gauge
          :title="name"
          :current="progress"
          :target="target"
          :colour="gaugeColour"
        ></gauge>
      </div>
      <div v-else>
        <span style="display: none"> {{ (gif = stars) }} </span>
        <br />
        <b-card-img :src="image"></b-card-img>
        <b-list-group flush>
          <b-list-group-item>Achievement Complete!</b-list-group-item>
          <b-list-group-item
            ><strong>Charity Name:</strong> {{ name }}
          </b-list-group-item>
          <b-list-group-item
            ><strong>Target:</strong> {{ target.toLocaleString() }}
          </b-list-group-item>
          <b-list-group-item
            ><strong>Current:</strong>
            {{ progress.toLocaleString() }}
          </b-list-group-item>
        </b-list-group>
      </div>

      <br />

      <b-list-group flush>
        <b-list-group-item>
          <div
            :style="style"
            @mouseover="sendEvent('charity', 'hover', 'charity-message')"
          >
            <b-card
              align="center"
              id="charityCard"
              header="Twitch Charity Plea"
            >
              <b-card-text>{{ message }}</b-card-text>
            </b-card>
          </div>
        </b-list-group-item>
      </b-list-group>
    </b-card>
  </div>
</template>

<script>
import Gauge from "@/components/utils/Gauge.vue";
import CharityAPI from "@/api/charity.js";
import ConfigAPI from "@/api/config.js";
import hearts from "@/assets/hearts.gif";
import stars from "@/assets/stars.gif";
import trophy from "@/assets/trophy.gif";
import { setInterval, setTimeout } from "timers";
import BitsAPI from "@/api/bits.js";

export default {
  name: "charity",
  data() {
    return {
      state: "",
      progress: 1,
      target: 10,
      image: trophy,
      channelName: "",
      message: "Help Donate To Charity ♥️",
      name: "Twitch Charity",
      // images
      gif: "",
      gifOne: stars,
      gifTwo: hearts,
      trophy: trophy,

      channelName: "",

      //theme settings
      ButtonTxtColour: "#FFFFFF",
      ButtonBkgColour: "#5583c7",
      gaugeColour: "#5583c7",
      userFollows: false,
    };
  },
  mounted() {
    this.channelName = ConfigAPI.getUsername();

    this.setConfig();
    this.getCharities();

    this.eventBus.$on("charity-progress-update", this.progressUpdate);

    this.$store.watch(
      (state) => state.userId,
      (userId) => {}
    );
    this.state = this.$store.getters.getReleasedState();
  },
  activated: function () {
    ga("set", "page", "/charity");
    ga("send", "pageview");
  },
  methods: {
    setConfig: function () {
      var globalConfig = ConfigAPI.getGlobalConfig();

      if (globalConfig.images) {
        var images = globalConfig.images;
        if (images.one) {
          this.gifOne = images.one;
        }
        if (images.two) {
          this.gifTwo = images.two;
        }
      }

      var config = ConfigAPI.getBroadcasterConfig();
      if (config.charity) {
        var charity = config.charity;
        if (charity.gaugeColour) {
          this.gaugeColour = config.charity.gaugeColour;
        }
      }

      if (config.panel_settings) {
        var panel = config.panel_settings;
        if (panel.font_colour) {
          this.ButtonTxtColour = panel.font_colour;
        }
        if (panel.background_colour) {
          this.ButtonBkgColour = panel.background_colour;
        }
      }
      return;
    },
    getCharities: function () {
      CharityAPI.getCharities()
        .then((resp) => {
          if (resp.data.count) {
            var charity = resp.data.charity_campaign;
            this.progress = charity.current_amount.value;
            if (this.progress == 0) {
              this.progress = 1;
            }
            this.target = charity.target_amount.value;

            this.name = charity.charity_name;
          }
        })
        .catch((error) => {});

      var config = ConfigAPI.getBroadcasterConfig();
      if (config.charity) {
        var charity = config.charity;
        if (charity.gauge_colour) {
          this.gaugeColour = config.charity.gauge_colour;
        }
      }
    },
    progressUpdate: function (progress) {
      this.progress = progress.current_amount;

      this.gif = this.gifOne;

      setTimeout(
        function () {
          this.gif = this.gifTwo;
        }.bind(this),
        60000
      );

      setTimeout(
        function () {
          this.gif = "";
        }.bind(this),
        120000
      );
    },
    playBalance: function () {
      BitsAPI.showBalance();
    },
  },
  computed: {
    style() {
      return {
        "--btnBkgColour": this.ButtonBkgColour,
        "--btnFontColour": this.ButtonTxtColour,
      };
    },
  },
  components: {
    Gauge,
  },
};
</script>

<style scoped>
.btn-secondary {
  background-color: var(--btnBkgColour);
  color: var(--btnFontColour);
}

.card {
  border-color: var(--btnBkgColour);
  border-style: none;
}

.card #charityCard {
  border-style: groove;
}

.card-header {
  background-color: var(--btnBkgColour);
  color: var(--btnFontColour);
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>

<style>
.popover {
  max-width: none;
}
</style>
